import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./root";
import "./index.css";
import { Providers } from "./providers";
import { I18nProvider } from "./components/providers/i18nProvider";
import { ConnectionBanner } from "./components/ConnectionBanner";
import { PostHogPageviews } from "./components/PostHogPageviews";
import { AppToaster } from "@/components/ui/AppToaster";
import { initBrowserExtensionNoiseGuard } from "@/lib/browserExtensionNoiseGuard";
import { initErrorReporting } from "@/lib/errorReporter";
import { initPostHog } from "@/lib/posthog";
import { api } from "@/lib/axios";

initBrowserExtensionNoiseGuard();
initPostHog();
initErrorReporting();

// QA-only: install the perf monitor interceptors. import.meta.env is
// statically replaced at compile time, so production builds drop this branch
// entirely: the perfMonitor module is never imported, never loaded, and no
// axios interceptors are ever registered.
if (import.meta.env.VITE_QA_MODE === "true") {
  const { installPerfMonitor } = await import("@/lib/perfMonitor");
  installPerfMonitor(api);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nProvider>
      <Providers>
        <BrowserRouter>
          <PostHogPageviews />
          <ConnectionBanner />
          <App />
          <AppToaster />
        </BrowserRouter>
      </Providers>
    </I18nProvider>
  </React.StrictMode>
);
